import { restResourceRequester } from "../rest-resource-requester";
import { CreateUserRequest } from "./create-user/CreateUserRequest";
import { CreateUserResponse } from "./create-user/CreateUserResponse";

interface UserRestResource {
  createUser(request: CreateUserRequest): Promise<CreateUserResponse>;
}

const REST_RESOURCE_NAME = "/user";

/**
 * PUT /user
 */
const createUser = restResourceRequester<CreateUserRequest, CreateUserResponse>(
  "PUT",
  (request) => {
    return `${REST_RESOURCE_NAME}`;
  },
  (request) => JSON.stringify(request),
);

export const userRestResource: UserRestResource = {
  createUser: createUser,
};
